import React, { Component } from 'react'
import { meta } from 'helpers/decorators'
import { History } from 'containers/pages'

@meta({
  title: 'My Region Office - logs',
  intlKey: 'pageTitle.mro_logs'
})
class MyRegionOfficeLogs extends Component {
  static propTypes = {}
  static defaultProps = {}

  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return <History decoActions="myOrganization" {...this.props} />
  }
}

export default MyRegionOfficeLogs
